import { Heading, useLargeFromMediaQuery } from '@madpaws/design-system';
import React from 'react';

import { DEFAULT_SERVICE_NAME, SERVICE_TYPE_BY_NAME_MAPPING } from '~/common/constants/search';

import type { SearchFilters } from '~/common/types/search';

type Props = {
  children: React.ReactElement;
  searchFilters: SearchFilters;
  serviceSlug: string;
};

export const DynamicHeader = ({
  searchFilters,
  serviceSlug,
  children,
}: Props): React.ReactElement => {
  const isLargeFromViewport = useLargeFromMediaQuery();

  const {
    location: {
      address: { suburb },
    },
  } = searchFilters;

  const serviceName = SERVICE_TYPE_BY_NAME_MAPPING[serviceSlug]?.seoTitle || DEFAULT_SERVICE_NAME;
  const formattedServiceName =
    serviceName.charAt(0).toUpperCase() + serviceName.slice(1).toLowerCase();

  return (
    <div>
      <Heading level={1} size={isLargeFromViewport ? 'small2x' : 'small3x'}>
        {`${formattedServiceName} in ${suburb}`}
      </Heading>
      {children}
    </div>
  );
};
